import { useMusic24Capabilities } from './useMusic24Capabilities';

/**
 * Whether the country breakdown should render.
 *
 * Capability only, with no public-share escape hatch: `markets.*` aggregates
 * over the caller's own follows and refuses a share token with FORBIDDEN, so a
 * share page has nothing to show here either way. The licence slice is the source, not the
 * session token's frozen claims.
 */
export const useCanFilterGeographically = (): boolean => useMusic24Capabilities().canFilterGeographically;
